import { module } from 'modujs';
import { gsap } from 'gsap';
import { SplitText } from "../libs/gsap/SplitText";

gsap.registerPlugin(SplitText);

export default class extends module {
    constructor(m) {
        super(m);

		if(window.isMobile) return;

		this.events = {
			mouseenter: {
				wrap: 'hover'
			}
		}
    }

    init() {
		if(window.isMobile) return;
		this.split = new SplitText(this.$('label'), {
			type: 'chars, words'
		});
    }

	hover(delay = 0) {
		if(window.isMobile) return;

		if(this.hoverTl != undefined) {
			this.hoverTL.kill();
		}
		this.hoverTL = gsap.timeline({repeat: 0});

		this.hoverTL.to(this.split.chars, {
			alpha: 0,
			duration: 0.05,
			delay: delay,
			stagger: {
				amount: 0.1,
				from: "random",
			}
		});
		
		this.hoverTL.to(this.split.chars, {
			alpha: 1,
			duration: 0.1,
			stagger: {
				amount: 0.2,
				from: "random",
			}
		});
	}
}
